import {
  Badge,
  Cushion,
  FlexContainer,
  Grid,
  MaxWidth,
  Rectangle,
  Shimmer,
  ShimmerTypography,
} from '@pitchero/react-ui';
import React from 'react';
import useBreakpoint from '../../lib/use-breakpoint';

const HeaderLoadingState = () => {
  const isMobile = useBreakpoint();
  return (
    <Rectangle fill="#000" component="div" style={{ minHeight: '200px' }}>
      <MaxWidth maxWidth={1366} center>
        <Cushion all="medium" component="div">
          <FlexContainer flexDirection="column" style={{ gap: '20px' }}>
            <ShimmerTypography
              preset="name"
              width={180}
              margin={`1.5px ${isMobile ? '0' : 'auto'}`}
            />
            {isMobile ? (
              <Grid
                columns="60px 60% 15%"
                columnGap="20px"
                alignItems="center"
                rows="1fr 1fr"
                rowGap="20px"
              >
                <Badge primary="#CCCCCC" secondary="#CCCCCC" style={{ width: '100%' }} size={40} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Badge primary="#CCCCCC" secondary="#CCCCCC" style={{ width: '100%' }} size={40} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
              </Grid>
            ) : (
              <Grid
                columns="70px 1fr 100px 100px 1fr 70px"
                columnGap="20px"
                alignItems="center"
                rows="1fr"
              >
                <Badge primary="#CCCCCC" secondary="#CCCCCC" style={{ width: '100%' }} size={40} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Shimmer style={{ borderRadius: 4 }} height={30} />
                <Badge primary="#CCCCCC" secondary="#CCCCCC" style={{ width: '100%' }} size={40} />
              </Grid>
            )}
          </FlexContainer>
        </Cushion>
      </MaxWidth>
    </Rectangle>
  );
};

export default HeaderLoadingState;
